<template>
  <section v-if="!isReady" class="topics">
    <yn-loading />
  </section>

  <yn-with-title v-else :title="'Topic search'" class="topics">
    <section class="topic-list-wrapper">
      <div>This is a list of public topics. You can join any of them and start labelling.</div>
      <ul v-if="collection.length" class="topic-list">
        <li v-for="item in collection" :key="item.id" class="topic-list-item">
          <label class="topic-list-item-stats">
            <span>{{ item.progress.done }} / {{ item.progress.total }}</span>
          </label>
          <h4>
            {{ item.title }}
          </h4>
          <div v-if="item.description" class="topic-list-item-description">{{ item.description }}</div>
          <div v-else class="topic-list-item-description"><i>no description</i></div>
          <div class="topic-list-item-action">
            <yn-button
              v-if="!item.isAnnotator"
              variant="contained"
              color="primary"
              :disabled="joinRequestPendingCollection && joinRequestPendingCollection.includes(item.id)"
              @click="join(item)"
              >Join</yn-button
            >
            <router-link v-else :to="`/labelling/${item.id}`"><yn-button>Open</yn-button></router-link>
          </div>
        </li>
        <li v-if="isAppendRequestPending">
          <yn-loading :inline="true" />
        </li>
        <li
          v-else-if="total > collection.length"
          style="height: 100px; display: flex; align-items: center; justify-content: center;"
        >
          <yn-button variant="text" @click="more">more</yn-button>
        </li>
      </ul>
    </section>
  </yn-with-title>
</template>

<script>
import { mapState } from 'vuex';

import Loading from './../common/Loading';
import Button from './../common/Button';
import WithTitle from './../common/_WithTitle';

export default {
  components: {
    'yn-loading': Loading,
    'yn-button': Button,
    'yn-with-title': WithTitle
  },
  meta: {
    title: 'Home'
  },
  data() {
    return {
      from: new Date(),
      isReady: false
    };
  },
  computed: {
    ...mapState({
      total: s => s.labelling.search.total,
      // size: s => s.search.size,
      // skip: s => s.search.skip,
      // sort: s => s.search.sort,
      collection: s => s.labelling.search.collection,
      isAppendRequestPending: s => s.labelling.search.isAppendRequestPending,
      isAppendRequestFailed: s => s.labelling.search.isAppendRequestFailed,
      joinRequestPendingCollection: s => s.labelling.search.joinRequestPendingCollection
    })
  },
  //   watch: {
  //     $route: {
  //       handler() {
  //         const params = new URLSearchParams(document.location.search);
  //         this.$store.dispatch('search/getCollection', {
  //           projectId: this.$route.params.id,
  //           size: params.get('size') ? +params.get('size') : 5,
  //           skip: params.get('skip') ? +params.get('skip') : 0,
  //           sort: params.get('sort') || null
  //         });
  //       },
  //       immediate: true
  //     }
  //   },
  async created() {
    await this.$store.dispatch('labelling/search/append', {
      projectId: this.$route.params.id,
      size: 5,
      skip: 0,
      initialize: true
    });
    this.isReady = true;
  },
  methods: {
    async edit(id) {
      this.$router.push({ path: `/topics/${id}/edit` });
    },
    more() {
      this.$store.dispatch('labelling/search/append', {
        projectId: this.$route.params.id,
        size: 5,
        skip: this.collection && this.collection.length
      });
    },
    async join(item) {
      try {
        await this.$store.dispatch('labelling/search/join', item);
        this.$toast.success({
          title: 'Join completed',
          message: 'You successfully joined a public topic.'
        });
      } catch (e) {
        this.$toast.error({
          title: 'Join failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.topics {
  position: relative;
  padding-bottom: 1rem;

  .action-wrapper {
    padding: 1rem 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .topic-list-wrapper {
    display: grid;
    grid-gap: 1rem;
    grid-template-rows: max-content max-content;
  }

  .topic-list {
    list-style: none;
    margin: 0;
    .topic-list-item {
      width: 100%;
      position: relative;

      display: grid;
      grid-gap: 0 1rem;
      grid-template-columns: 75px minmax(0, 1fr) 75px;
      grid-template-rows: max-content max-content;
      color: #2d313d;
      transition: all 0.3s ease 0s;
      margin-top: 1.5rem;
      margin-bottom: 3rem;

      .topic-list-item-stats {
        grid-column: 1/2;
        grid-row: 1/3;
        align-self: center;
        justify-self: center;

        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #fff;
        border: 2px solid #2d313d;
        top: 50%;

        font-weight: 700;
        font-size: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #2d313d;
        padding: 0.25rem;
        text-align: center;
      }

      > h4 {
        grid-row: 1/2;
        grid-column: 2/3;
        font-size: 1.5rem;
        // margin: 0 0 1rem;
        padding: 0;
        line-height: 1.4;
        letter-spacing: 1px;
        color: #2d313d;
      }

      .topic-list-item-description {
        grid-row: 2/3;
        grid-column: 2/3;
      }

      .topic-list-item-action {
        grid-row: 1/3;
        grid-column: 3/4;
        align-self: center;
        justify-self: center;
        text-align: center;
      }

      &:after {
        position: absolute;
        height: 1px;
        width: 100%;
        background-color: #dee2e6;
        bottom: -20px;
        text-align: center;
        content: '';
        // margin: 0 auto;
        right: 0;
        left: 0;
      }
    }
  }
}
</style>
